

export enum ModelTypeTypeNameIds
{

    EntityType = "EntityType",
    OrderType = "OrderType",
    JournalType = "JournalType",
}